export default {
  methods: {
    validateBeforeSubmit(event: Event): void {
      this.$refs.form.validate().then(success => {
        if (!success) {
          const adjust = -90;
          const speed = 400;
          const firstInvalidObject = document.getElementsByClassName('is-invalid')[0];
          const elemY = firstInvalidObject.getBoundingClientRect().top;
          const position = window.pageYOffset + elemY + adjust;
          $('body,html').animate({scrollTop:position}, speed, 'swing');
          event.preventDefault()
        }
      });
    },
  },
}
